import Cookies from 'cookies-js';
import * as types from '../mutation-types';


// initial state
const state = {
  userIsLogged: false,
  user: {},
  groups: [],
};

// getters
const getters = {
  userIsLoggedState: state => state.userIsLogged,
  getUser: state => state.user,
};

// mutations
const mutations = {
  [types.USER_LOG_IN](state, account) {
    state.userIsLogged = true;
    state.user = account;
  },
  [types.USER_LOG_OUT](state) {
    state.userIsLogged = false;
  },
  [types.USER_IS_LOGGED](state) {
    state.userIsLogged = true;
  },
};

const actions = {
  loginUser: ({ commit }, account) => {
    const acceptedCookie = JSON.stringify(account);
    Cookies.set('authenticatedAccount', acceptedCookie, { expires: 86400 });
    commit(types.USER_LOG_IN, account);
  },
  logoutUser: ({ commit }) => {
    Cookies.expire('authenticatedAccount');
    Cookies.expire('sessionid');
    commit(types.USER_LOG_OUT);
  },
  setUserIsLogged: ({ commit }) => {
    commit(types.USER_IS_LOGGED);
  },
  setUserInfo: ({ commit }) => {
    if (Cookies.get('authenticatedAccount')) {
      const accountInfo = JSON.parse(Cookies.get('authenticatedAccount'));
      commit(types.USER_LOG_IN, accountInfo);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js